import { render, staticRenderFns } from "./CategoriesPanel.vue?vue&type=template&id=ff120b04&scoped=true"
import script from "./CategoriesPanel.vue?vue&type=script&lang=js"
export * from "./CategoriesPanel.vue?vue&type=script&lang=js"
import style0 from "./CategoriesPanel.vue?vue&type=style&index=0&id=ff120b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff120b04",
  null
  
)

export default component.exports